<div class="fullscreen-wrapper">

  <mat-card appearance="outlined" class="verificationCard">
    <div class="two-factor-container">
      <h2 class="titleCenter">{{ '2faHeader' | translate }}</h2>

      <mat-form-field appearance="outline" class="otp-input">
        <mat-label>{{ '2faAuthCode' | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="otp"
          maxlength="8"
          autocomplete="one-time-code"
          type="text"
          pattern="[0-9]*"
          inputmode="numeric"
          />
      </mat-form-field>

      <div class="btn-group">
        <button mat-stroked-button color="warn" (click)="cancel()">{{'cancel' | translate}}</button>
<!--        <button class="button-color"
          mat-raised-button
          color="primary"
          [disabled]="isCooldown"
          (click)="sendCodeToEmail()">
          {{ isCooldown ? ('Resend in ' + countdown + 's') : ('sendOTPByMail' | translate) }}
        </button>-->
        <button class="button-color" mat-raised-button (click)="verify()"
        color="primary">{{ 'verify2fa' | translate }}</button>
      </div>

      @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </div>
  </mat-card>
</div>
